var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcUserRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1060_148)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12 18C11.3078 18 10.6311 17.7947 10.0555 17.4101C9.47993 17.0256 9.03133 16.4789 8.76642 15.8394C8.50152 15.1999 8.4322 14.4961 8.56725 13.8172C8.7023 13.1383 9.03564 12.5146 9.52513 12.0251C10.0146 11.5356 10.6383 11.2023 11.3172 11.0673C11.9961 10.9322 12.6999 11.0015 13.3394 11.2664C13.9789 11.5313 14.5256 11.9799 14.9101 12.5555C15.2947 13.1311 15.5 13.8078 15.5 14.5C15.4989 15.4279 15.1299 16.3176 14.4737 16.9737C13.8176 17.6299 12.9279 17.9989 12 18Z",
    fill: "#28A8E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.64 16.772C14.316 17.1566 13.9118 17.4658 13.4558 17.6779C12.9998 17.89 12.5029 17.9999 12 17.9999C11.4971 17.9999 11.0002 17.89 10.5442 17.6779C10.0882 17.4658 9.68403 17.1566 9.36 16.772C8.63996 17.2183 8.04546 17.8407 7.63256 18.5804C7.21966 19.3201 7.00196 20.1528 7 21C7 21.2652 7.10536 21.5195 7.29289 21.7071C7.48043 21.8946 7.73478 22 8 22H16C16.2652 22 16.5196 21.8946 16.7071 21.7071C16.8946 21.5195 17 21.2652 17 21C16.998 20.1528 16.7803 19.3201 16.3674 18.5804C15.9545 17.8407 15.36 17.2183 14.64 16.772Z",
    fill: "#28A8E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M21.0002 12.0001C20.7554 12.0006 20.5191 11.9109 20.3362 11.7481L12.0002 4.33812L3.6642 11.7481C3.46582 11.9242 3.20561 12.0143 2.9408 11.9986C2.676 11.9828 2.42831 11.8625 2.2522 11.6641C2.0761 11.4657 1.98601 11.2055 2.00177 10.9407C2.01752 10.6759 2.13782 10.4282 2.3362 10.2521L11.3362 2.25212C11.5191 2.0894 11.7554 1.99951 12.0002 1.99951C12.245 1.99951 12.4813 2.0894 12.6642 2.25212L21.6642 10.2521C21.816 10.3868 21.9232 10.5644 21.9716 10.7614C22.02 10.9585 22.0074 11.1656 21.9353 11.3552C21.8633 11.5449 21.7352 11.7082 21.5682 11.8233C21.4012 11.9385 21.2031 12.0002 21.0002 12.0001Z",
    fill: "#28A8E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M12 4.33789L4 11.4489V20.9999C4 21.2651 4.10536 21.5195 4.29289 21.707C4.48043 21.8945 4.73478 21.9999 5 21.9999H8C7.73478 21.9999 7.48043 21.8945 7.29289 21.707C7.10536 21.5195 7 21.2651 7 20.9999C7.00196 20.1527 7.21966 19.32 7.63256 18.5803C8.04546 17.8406 8.63996 17.2182 9.36 16.7719C8.80886 16.143 8.50345 15.3361 8.5 14.4999C8.5 13.5716 8.86875 12.6814 9.52513 12.025C10.1815 11.3686 11.0717 10.9999 12 10.9999C12.9283 10.9999 13.8185 11.3686 14.4749 12.025C15.1313 12.6814 15.5 13.5716 15.5 14.4999C15.4965 15.3361 15.1911 16.143 14.64 16.7719C15.36 17.2182 15.9545 17.8406 16.3674 18.5803C16.7803 19.32 16.998 20.1527 17 20.9999C17 21.2651 16.8946 21.5195 16.7071 21.707C16.5196 21.8945 16.2652 21.9999 16 21.9999H19C19.2652 21.9999 19.5196 21.8945 19.7071 21.707C19.8946 21.5195 20 21.2651 20 20.9999V11.4489L12 4.33789Z",
    fill: "#28A8E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1060_148",
    x: 0,
    y: 0,
    width: 24,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1060_148"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserRed);
export default __webpack_public_path__ + "static/media/ic_user_red.993cd16bcc498a0a600ffe52634a0184.svg";
export { ForwardRef as ReactComponent };